module.exports = __webpack_public_path__ + "static/media/mage.46d8d25f.svg";